import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_DOCUMENT_IMPORTER_TEMPLATES } from './get-document-importer-templates.hook';
import { GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID } from './get-document-importer-template-by-id.hook';

export const CREATE_DOCUMENT_IMPORTER_TEMPLATE = gql`
  mutation createDocumentImporterTemplate($payload: CreateDocumentImporterTemplateInput!) {
    createDocumentImporterTemplate(payload: $payload) {
      _id
      title
      companyId
    }
  }
`;

export const useCreateDocumentImporterTemplate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [createDocumentImporterTemplate, { loading }] = useMutation(
    CREATE_DOCUMENT_IMPORTER_TEMPLATE,
    {
      onCompleted: data => {
        if (data?.createDocumentImporterTemplate?._id) {
          showNotification({
            isIcon: false,
            type: NOTIFICATION_TYPE.success,
            message: t('documentImporter.notifications.created'),
          });
          if (onSuccess) {
            onSuccess();
          }
        }
      },
      refetchQueries: [GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID, GET_DOCUMENT_IMPORTER_TEMPLATES],
    }
  );
  return { createDocumentImporterTemplate, loading };
};
